import PaywallUtils from "Utils/PaywallUtils";
import { linkedInReplyState } from "../state";
import { addLinkedInAccountPopupState } from "Components/PreviewPopup/AddLinkedInAccountPopup";

const openAddLinkedInAccountPopup = async () => {
  const { isLimitReached = false, liAutomationEnabled = false } =
    await linkedInReplyState.getCurrentTeam();
  if (!liAutomationEnabled) {
    PaywallUtils.upgradeUtilsFunction("linkedInAutomationNotEnabled", false);
    return;
  }
  if (isLimitReached) {
    PaywallUtils.upgradeUtilsFunction("linkedInAccountLimitReached", false);
    return;
  }
  addLinkedInAccountPopupState.setShowPopup(true);
};

export { openAddLinkedInAccountPopup };
export default openAddLinkedInAccountPopup;
